import React, { useState, useEffect } from "react";
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Col, Row } from "reactstrap";
import { Dropdown } from 'primereact/dropdown';
import axios from 'axios';

const LinkContactJob = ({ setSelectedScheduleJob, setSelectedScheduleContacts, setFormErrors, formErrors }) => {
    // State for dropdowns and API data
    const [typeInterviewval, settypeInterviewval] = useState([]);
    const [typeInterviewcontact, settypeInterviewcontact] = useState([]);
    const [subtypeget, setSubtypeget] = useState(null);
    const [prioritycontact, setPrioritycontact] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [dialogVisible, setDialogVisible] = useState(false);
    const [selectedContacts, setSelectedContacts] = useState([]);


    // Handle job selection from Dropdown
    const handleJobChange = (e) => {
        setSubtypeget(e.value);
        setSelectedScheduleJob(e.value ? [e.value.id] : []);
        if (e.value) {
            setFormErrors((prev) => ({ ...prev, selectedScheduleJob: '' }));
        }
    };

    // State for dialog and table
    //   const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
    //   const [searchText, setSearchText] = useState('');
    //   const [selectedJobs, setSelectedJobs] = useState([]);
    //   const [selectedJobTitles, setSelectedJobTitles] = useState('');
    //   const [selectedContacts, setSelectedContacts] = useState('');

    // Fetch jobs from API
    const getjobs = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-jobs/?status=Approved/Open`, {});
            const transformedData = response.data.results.map((job) => ({
                name: job.job_title,
                id: job.job_id,
            }));
            settypeInterviewval(transformedData);

        } catch (error) {
            console.error('Error fetching jobs:', error);
        }
    };

    // Fetch contacts from API
    const getallactivecontacts = async () => {
        try {
            const response = await axios.get(`/api/v1/contacts/?status=Active`, {});
            const transformedData = response.data.results.map((contact) => ({
                name: contact.first_name,
                id: contact.id || index
            }));
            settypeInterviewcontact(transformedData);
        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
    };

    // Fetch data on component mount
    useEffect(() => {
        getjobs();
        getallactivecontacts();
    }, []);

    const handleIconClick = () => {
        setDialogVisible(true);
    };
    const closeDialog = () => {
        setDialogVisible(false);
    };

    const handleSave = () => {
        const selectedNames = selectedContacts.map((contact) => contact.name).join(', ');
        const selectedIds = selectedContacts.map((contact) => contact.id);
        setPrioritycontact(selectedNames);
        setSelectedScheduleContacts(selectedIds);
        // Clear error for selectedScheduleContacts when contacts are selected
        if (selectedIds.length > 0) {
            setFormErrors((prev) => ({ ...prev, selectedScheduleContacts: '' }));
        }
        setDialogVisible(false);
    };

    const filteredContacts = typeInterviewcontact.filter((contact) => {
        const name = contact.name || ''; // Fallback to empty string if name is null/undefined
        const id = contact.id != null ? contact.id.toString() : ''; // Fallback to empty string if id is null/undefined
        return (
            name.toLowerCase().includes(searchText.toLowerCase()) ||
            id.includes(searchText.toLowerCase())
        );
    });

    //   // Combine job and contact data for the table
    //   const jobs = typeInterviewval.map(job => ({
    //     id: job.id,
    //     title: job.name,
    //     contact: prioritycontact.length > 0 
    //       ? prioritycontact.map(contact => contact.name).join(', ')
    //       : 'No Contact Assigned'
    //   }));

    //   // Filter jobs based on search text
    //   const filteredJobs = jobs.filter(
    //     (job) =>
    //       job.title.toLowerCase().includes(searchText.toLowerCase()) ||
    //       job.contact.toLowerCase().includes(searchText.toLowerCase()) ||
    //       job.id.toString().includes(searchText)
    //   );

    //   // Handle save action
    //   const handleSave = () => {
    //     setSelectedJobTitles(selectedJobs.map((job) => `${job.title}, ${job.id}`).join(', '));
    //     setSelectedContacts(selectedJobs.length > 0 
    //       ? selectedJobs.map((job) => job.contact).filter(contact => contact !== 'No Contact Assigned').join(', ')
    //       : prioritycontact.map(contact => contact.name).join(', '));
    //     setJobDetailsVisible(false);
    //   };

    //   // Handle refresh action
    //   const handleRefresh = () => {
    //     setSelectedJobs([]);
    //     setSearchText('');
    //     setSelectedJobTitles('');
    //     setSelectedContacts('');
    //     setsubtypeget(null);
    //     setprioritycontact([]);
    //   };



    return (
        <>
            <Row className="mb-4">
                <Col xl={6}>
                    <div className="flex flex-column">
                        <label htmlFor="Priority">Job</label>
                        <Dropdown
                            value={subtypeget}
                            onChange={handleJobChange}
                            options={typeInterviewval}
                            optionLabel="name"
                            placeholder="Select a job"
                            className="w-full search-option"
                        />
                        {formErrors.selectedScheduleJob && (
                            <small className="p-error">{formErrors.selectedScheduleJob}</small>
                        )}
                    </div>
                </Col>
                <Col xl={6}>
                    <div className="p-field flex flex-column">
                        <label htmlFor="contact" className="block">
                            Contact                        </label>
                        <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                            <InputText
                                id="contactdetails"
                                value={prioritycontact}
                                // onChange={(e) => setPrioritycontact(e.target.value)}
                                placeholder="Select Contacts"
                                className="w-full"
                                style={{ paddingRight: '2rem' }} // Ensure space for the icon
                            />
                            <i
                                className="pi pi-chevron-down"
                                onClick={handleIconClick}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                }}
                            ></i>
                        </div>
                        {formErrors.selectedScheduleContacts && (
                            <small className="p-error">{formErrors.selectedScheduleContacts}</small>
                        )}

                        <Dialog
                            header="Select Contacts"
                            visible={dialogVisible}
                            onHide={closeDialog}
                            style={{ width: '40vw' }}
                            breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                            className="cand-details"

                        >

                            {/* Search Bar */}
                            <Col lg={6}>
                                <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                    <InputText
                                        placeholder="Search Candidates"
                                        value={searchText}
                                        onInput={(e) => setSearchText(e.target.value)}
                                        style={{ paddingRight: '2rem' }}
                                    />
                                    <i
                                        className="pi pi-search"
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '49%',
                                            transform: 'translateY(-50%)',
                                        }}
                                    ></i>
                                </div>
                            </Col>
                            <DataTable
                                value={filteredContacts}
                                paginator
                                rows={5}
                                selection={selectedContacts}
                                onSelectionChange={(e) => setSelectedContacts(e.value)}
                                dataKey="id"
                                rowsPerPageOptions={10}
                                size="small"
                            >
                                <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />
                                <Column field="name" header="Contact Name" />
                            </DataTable>

                            {/* Actions */}
                            <div className="d-flex  mt-3">
                                <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>Save</button>
                                <button type="button" className="btn btn-primary btn-main" onClick={closeDialog}>Cancel</button>
                            </div>
                        </Dialog>
                    </div>
                </Col>
            </Row>

        </>
    );
};

export default LinkContactJob;